export interface Region {
  name: string
  logo: string
  plan: string
  apiBaseUrl: string
  recordWebUrl: string
  envKey: string
  prod: boolean
}

export const regions: Region[] = [
  {
    name: '中国',
    logo: 'i-lucide-flag',
    plan: 'China',
    prod: true,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_CN || 'https://platform.enjoi.spatialwalk.top',
    recordWebUrl: import.meta.env.VITE_RECORD_WEB_URL || 'https://record.spatialwalk.ai',
    envKey: 'cn',
  },
  {
    name: '美国',
    logo: 'i-lucide-globe',
    plan: 'USA',
    prod: true,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_US || 'https://platform.enjoi-us.spatialwalk.cloud',
    recordWebUrl: import.meta.env.VITE_RECORD_WEB_URL || 'https://record.spatialwalk.ai',
    envKey: 'us',
  },
  {
    name: '测试',
    logo: 'i-lucide-bug',
    plan: 'Test',
    prod: false,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_TEST || 'https://platform.enjoi-test.spatialwalk.top',
    recordWebUrl: import.meta.env.VITE_RECORD_WEB_URL || 'https://record.spatialwalk.ai',
    envKey: 'test',
  },
  {
    name: '开发',
    logo: 'i-lucide-code',
    plan: 'Dev',
    prod: false,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL_DEV || 'http://localhost:8080',
    recordWebUrl: import.meta.env.VITE_RECORD_WEB_URL || 'https://record.spatialwalk.ai',
    envKey: 'dev',
  },
].filter(region => import.meta.env.VITE_ENV === 'prod' ? region.prod : !region.prod)
